import Table from './components/Table';
import FileIcon from './components/FileIcon';
import reducer, { FilesState } from './reducers';

export default reducer;
export {
  FileIcon,
  Table,
};
export type {
  FilesState,
};
